<template>
    <router-link v-if="hasAccountId && currentPractice && currentPractice.allow_connect_referral" :to="{ name: 'Referral' }" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
            <div class="icon">
                <i class="bi bi-people-fill"></i>
            </div>
        </div>
        <div class="text">
            <div><strong>Referrals</strong></div>
            <div v-if="loading" class="text-description">
                Loading referrals...
            </div>
            <div v-else-if="error" class="text-description text-danger">
                Error loading referrals
            </div>
            <div v-else-if="!hasCode" class="text-description">
                <span>{{ noCodeMessage }}</span>
            </div>
            <div v-else class="text-description">
                <span>{{ referralCount }} {{ referralCount == 1 ? 'person' : 'people' }} have used your code</span>
            </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
    </router-link>
</template>

<script>
import api from '@/services/api';

export default {
    name: 'ReferralCountCard',
    data() {
        return {
            referralCount: 0,
            loading: true,
            error: false,
            hasCode: false,
            noCodeMessage: 'Click to create your referral code'
        }
    },
    computed: {
        hasAccountId() {
            return !!this.$store.state.currentAccountId;
        },
        currentPractice () {
            return this.$store.state.currentPractice;
        },
    },
    methods: {
        async fetchReferralCount() {
            if (this.hasAccountId) {
                this.loading = false;
                return;
            }
            const accountId = this.$store.state.currentAccountId;
            this.loading = true;
            this.error = false;
            try {
                const response = await api.get('/api/v1/referral/getReferralData', {
                    params: {
                        account_id: accountId,
                    }
                });
                this.hasCode = !!response.data.code;
                this.referralCount = response.data.referrals ? response.data.referrals.length : 0;
            } catch (e) {
                this.error = true;
                this.referralCount = 0;
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {
        // Initial fetch if account ID exists
        if (this.hasAccountId) {
            this.fetchReferralCount();
        }
        
        // Watch for account ID changes
        this.$watch(
            () => this.$store.state.currentAccountId,
            (newValue) => {
                if (newValue) {
                    this.fetchReferralCount();
                } else {
                    // Reset state when account ID is removed
                    this.loading = false;
                    this.error = false;
                    this.referralCount = 0;
                    this.hasCode = false;
                }
            }
        );
    }
}
</script>

<style scoped lang="scss">
.quick-link {
    text-decoration: none;
    display: flex;

    .icon-column {
        display: flex;
        flex-direction: column;
        margin-right: $spacer;
    }

    .icon {
        background: $swift-lighter-grey;
        border-radius: 10px;
        aspect-ratio: 1/1;
        font-size: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 70px;
    }

    .text {
        flex-grow: 1;
        margin-right: $spacer;
    }

    .text-description {
        line-height: 1.3em;
    }

    .arrow {
        img {
            width: 30px;
            margin-top: 10px;
        }            
    }

    &:hover {
        .icon {
            background: $swift-light-grey;
            transition: 0.5s;
        }
    }
}
</style>